
import { Options, Vue } from "vue-class-component"; //基本需要\
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  // readNewReportList,
  readPerfReport,
  readRecentTaskrecord,
  readTaskRecordDevices,
  readTaskRecordQuery,
  readPerformanceVersion,
  readGetDC,
  readGetDcReport,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchCreateReport,
  dispatchGetPerfReport,
  dispatchGetReportDetail,
  // dispatchGetPerformances,
  dispatchUploadReportImage,
  dispatchtaskRecordDevices,
  // dispatchGetNewReportList,
  dispatchDeleteReport,
  dispatchGetDateVersionList, //
  dispatchRecentTaskrecord,
  dispatchCreateReportByTask,
  dispatchUpdateReport,
  dispatchtaskRecordQuery,
  dispatchAovCopyPerfToReport,
  dispatchGetPerformanceVersion,
  dispatchClearCache,
  dispatchGetDc,
  dispatchGetDcReport,
  dispatchGetDcReportImage,
  dispatchSendXhookReport,
} from "@/store/performance/actions";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";

import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class DcStatistics extends Vue {
  //声明属性
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //报告的id
  public com_risk = "低风险"; //共同风险
  public loading = false; //加载
  public FPStrendShow = true;
  public contrast = true;
  public column_list = [];
  public column_list1 = [];
  public showMask = false;
  public maskImg = "";
  public imgBtn(sc: any) {
    this.showMask = true;
    this.maskImg = sc;
  }
  public maskBtn(ev: any) {
    if (!(this.$refs.mask as any).contains(ev.target)) {
      this.showMask = false;
    }
  }
  public get total_quantity() {
    // const list = [
    //   "局内采样位置和方向",
    //   "old-dc",
    //   "new-dc",
    //   "diff_dc",
    //   "Tris",

    //   "Verts",
    //   "dynamicBatchedDC",
    //   "staticBatchedDC",
    //   "monoUsed",
    //   "momomem",
    // ];
    const list = [
      { name: "局内采样位置" },
      { name: "方向" },
      { name: "old-dc" },
      { name: "new-dc" },
      { value: "DC差值", name: "diff_dc" },
      { value: "三角面", name: "Tris" },
      { value: "顶点", name: "Verts" },
      { value: "动态批量DC", name: "dynamicBatchedDC" },
      { value: "静态批量DC", name: "staticBatchedDC" },
      { value: "Mono内存", name: "monoUsed" },
      { value: "MaxMono", name: "momomem" },
    ];
    return list;
  }
  public get pgc_detail() {
    const list = [
      "序号",
      "位置",
      "变化",
      "新版本场景截图",
      "旧版本场景截图",
      "DC变化原因",
    ];
    return list;
  }
  public diff(item) {
    if (item.indexOf("+") != -1) {
      return item.replace("+", "") + "↑";
    }
    if (item.indexOf("-") != -1) {
      return item.replace("-", "") + "↓";
    } else {
      return item;
    }
  }
  public tableSecond() {
    for (let i in (this.dcData as any).dc_change_detail_pgc) {
      (this.dcData as any).dc_change_detail_pgc[i].dc_list.forEach((v) => {
        v.key = v.key.split("#");

        v.key[2] = v.key[2].split("_");
      });
    }
    for (let i in (this.dcData as any).dc_change_detail_top) {
      (this.dcData as any).dc_change_detail_top[i].dc_list.forEach((v) => {
        v.key = v.key.split("#");

        v.key[2] = v.key[2].split("_");
      });
    }
  }
  //新报告数据类型
  public new_report: any = {
    //新报告需要的数据类型
    id: 0,
    new_version: "",
    old_version: "",
    test_info: "",
    risk: null,
    create_date: "",
    settings: JSON.stringify({
      rule_settings: {
        change_rule: {
          increase_good: ["avg_fps"],
          threshold: {},
        },
        risk_rule: {},
        abs_risk_rule: {},
        tdr_risk_rule: {},
      },
      report_settings: {
        content: {
          core_index: ["avg_fps", "max_pss"], //核心指数
          trend_index: ["avg_fps", "max_pss"], //趋势指数
          exclude_scene: [], //排除场景
          exclude_device: [], //排除设备
          show_index: [
            "max_pss",
            "avg_fps",
            "fps_lt_10_pcnt",
            "fps_lt_18_pcnt",
            "fps_lt_25_pcnt",
          ], //显示索引
          index_type: {
            //索引类型
            basic: ["max_pss", "avg_fps"], //基础指标
            advance: ["fps_lt_10_pcnt", "fps_lt_18_pcnt", "fps_lt_25_pcnt"], //深度指标
            customize: [], //定制指标
          },
          trend_number: 10, //趋势指数
          trend_integrity: true, // 趋势图的完整性, 是否允许有缺失数据, 有断点, 1: 允许数据缺失, 0:不允许数据缺失
          red_only_change_value: false, // 是否仅标红变化值, 核心风险详情表格, 里面只标红括号内变化的值
          core_color_rule: false, // 核心指标标红规则, 1:变差就标红, 0: 超过阈值才标红
        },
        notify: {
          //通知
          email: {
            enable: false,
            receiver: [], //接收
          },
          wecom: {
            enable: false,
            receiver: [],
          },
          wecom_robot: {
            enable: false,
            receiver: [],
          },
        },
      },
    }),
    creator: "",
  };
  //获取核心数据的数据类型
  public get_core_data = {
    able_versions: {
      android_new_version: "",
      android_old_version: "",
      ios_new_version: "",
      ios_old_version: "",
    },
    auto_roadmap: {},
    report_data: {},
    report_list: [],
    report_list1: [],
    new_version: "",
    old_version: "",
    old_version1: "",
    all_devices: [],
    report_list2: [
      {
        scene_id: 0,
        scene: "",
        old_version: "",
        custom_index: [],
        device_list: [],
        old: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        new: [
          {
            data: { url: "", game_version: "" },
          },
        ],
        standard: [],
      },
    ],
    all_echart_versions: [],
    all_echart_data: [
      {
        performance_briefs: [{ device_id: 0 }],
        date_list: [],
        // echart_data: [],
        echart_data: {
          series: [],
          device_names: [],
          x_axis_format: [],
        },
      },
    ],
    project: {
      icon: "",
      project_name: "",
    },
    all_device_id: [],
    str_list: [],
    hero_list: [],
    skin_list: [],
    all_hero_skins: {},
    core_devices1: [],
    core_devices2: [],
    real_scenes: [],
    version_comparison_list: [],
    scene_image: [],
  };
  public newData = [];
  public newData1 = [];
  public imgUrl = "";
  public get_field(field: string) {
    const fields = {
      avg_fps: "平均FPS", // 平均FPS
      max_pss: "峰值PSS", // 峰值PSS
      max_mono_used: "maxMonoUsed(M)", // 峰值Used Mono
      max_mono_total: "峰值mono内存(M)", // 峰值Total Mono
      avg_cpu: "平均CPU", // 平均CPU
      fps_lt_10_pcnt: "FPS<=10占⽐(%)", // FPS<=10占有率(%)
      fps_lt_18_pcnt: "FPS>=18占⽐(%)", // FPS>=18占有率(%)
      fps_lt_25_pcnt: "FPS>=25占⽐(%)", // FPS>=25占有率(%)
      fps_lt_40_pcnt: "FPS>=40占⽐(%)", // FPS>=40占有率(%)
      cpu_lt_60_pcnt: "CPU<=60占⽐(%)", // FPS<=60占有率(%)
      cpu_lt_80_pcnt: "CPU<=80占⽐(%)", // FPS<=80占有率(%)
      dps: "dps",
      avg_dc: "平均DC", // 平均DC
      max_dc: "峰值DrawCall数", // 峰值DC
      max_triangle: "峰值三角形数", // 峰值三角形(万)
      duration: "耗时", // 耗时
      avg_flow: "流量(KB/S)", // 流量(KB/S)
      max_swap: "maxSwap",
      max_vss: "maxVss",
      max_swap_add_pss: "maxSwapAddPss",
      process_up_flow: "进程上行流量[KB/s]",
      process_down_flow: "进程下行流量[KB/s]",
      logic_up_flow: "逻辑上行流量[KB/s]",
      logic_down_flow: "逻辑下行流量[KB/s]",
      lag_cnt: "卡顿次数", // 卡顿次数
      single_peak_lag_cnt: "singlePeakLagCnt",
      multiple_peak_lag_cnt: "multiplePeakLagCnt",
      continue_low_lag_cnt: "continueLowLagCnt",
      lag_pcnt: "卡顿率", // 卡顿率
      lag_freq: "卡顿频率",
      id_row_start: "id_row_start",
      id_row_end: "id_row_end",
      id_frame_start: "id_frame_start",
      id_frame_end: "id_frame_end",
      avg_cpu_total: "avgCpuTotal",
      gc_cnt: "GC(次)", // gc_cnt
      gc_freq: "GC频率",
      cpu_temp: "CPU温度",
    };
    return typeConversion(field, fields, true); //类型转换
  }
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.name_search),
    });
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: readNewReportList(store)[0].id,
    // });
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.$route.query.report_id),
    // });

    //启用生成报告的接口

    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    this.corePerformance = [];
    await this.getCorePerformance();

    this.loading = false;
  }
  public old_text() {
    // if(readPerfReport(store).able_versions.android_old_version!=='' && readPerfReport(store).able_versions.ios_old_version==''){
    //   return 'android:'+readPerfReport(store).able_versions.android_old_version
    // }else if(readPerfReport(store).able_versions.android_old_version=='' && readPerfReport(store).able_versions.ios_old_version!==''){
    //    return 'ios'+readPerfReport(store).able_versions.ios_old_version
    // }
    let androidOld = readPerfReport(store).able_versions?.android_old_version;
    let iosOld = readPerfReport(store).able_versions?.ios_old_version;
    if (androidOld !== "" && iosOld == "") {
      return androidOld;
    }
    if (androidOld == "" && iosOld !== "") {
      return iosOld;
    }
    if (androidOld == "" && iosOld == "") {
      return "";
    } else if (androidOld !== "" && iosOld !== "") {
      return "android:" + androidOld + ",ios:" + iosOld;
    }
  }
  //获取场景iD
  public itemList = {};
  public itemList1 = {};
  public long = 0;
  public selected_scene =
    (this.get_core_data.all_echart_data as any[])[0]?.scene_id || "";
  public selected_scene1 =
    (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
  // 页面初始化
  public async mounted() {
    this.loading = true;
    if (this.$route.query.cur_version) {
      if (this.$route.query.project) {
        const project = Number(this.$route.query.project);
        // 记录一下最后访问的项目
        dispatchUpdateMyLastProject(store, { last_visit_project: project });
        saveLocalProject(String(project));
        saveLocalStorageProject(String(project));
        dispatchGetDeviceSpecs(store, {
          project: project,
        });
        dispatchGetDateVersionList(store, {
          project: project,
        });

        dispatchRecentTaskrecord(store, { project: project }); //表格对应label
        this.reload();
        // 获取当前报告名称列表
        await dispatchGetDcReport(store, {
          project: this.localProject,
          is_base: 0,
        });
        (this.name_search as any) = this.$route.query.cur_version;
        await dispatchGetMobaProjects(store, project);
        if (this.projectIsKing) {
          dispatchGetHeroSkin(store, project);
        }

        await dispatchGetDc(store, {
          project: project,
          cur_version: this.name_search,
          test_time: "",
          base_version: "",
        });
        // this.report_id = readNewReport(store).id;
        // await dispatchGetPerfReport(store, {
        //   project: project,
        //   report_id: Number(this.$route.query.report_id),
        // });
        // await this.showEdit();
        this.resBase64 = [];
        await this.dc_Data();
        await this.Dc_Performance.forEach((v: any) =>
          this.drawDcPerformance(v)
        );
        await this.Core_indicators.forEach((v: any, index: any) =>
          this.drawCoreIndicators(v, index)
        );

        await this.dc_change_list;
        await this.tableSecond();

        await this.getSpanArr(this.dc_change_list);

        // if (this.get_core_data.auto_roadmap != undefined) {
        //   this.selected_scene1 =
        //     (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
        //   this.imgData = readPerfReport(store).auto_roadmap[0]?.roadmap;

        //   if (this.imgData?.length > 0) {
        //     let deviceName = [];
        //     let deviceName1 = [];
        //     let dataObj = {};
        //     let dataObj1 = {};
        //     let FpsBox = [];
        //     let trajectoryBox = [];
        //     this.imgData.forEach((v) => {
        //       deviceName.push(v.device_name);
        //       this.column_list = deviceName;
        //       this.long = this.imgData?.length;
        //       dataObj[v.device_name] = v.fps;
        //     });
        //     deviceName1.push(this.imgData[0].device_name);
        //     dataObj1[this.imgData[0].device_name] = this.imgData[0].trajectory;
        //     this.imgUrl = this.imgData[0].trajectory;
        //     trajectoryBox.push(dataObj1);
        //     this.newData1 = trajectoryBox;
        //     console.log(this.newData1);

        //     this.column_list1 = deviceName1;
        //     FpsBox.push(dataObj);
        //     this.newData = FpsBox;
        //   }

        //   // this.imgData=[{device_name: "19X",fps: require("../../assets/test/1.jpg"),trajectory: "",}]
        // }

        // if (this.report_set.content.trend_scene) {
        //   if (this.report_set.content.trend_scene.length !== 0) {
        //     this.selected_scene = this.report_set.content.trend_scene[0];
        //   }
        // }

        //     console.log(this.get_core_data
        // .all_echart_data.length)
        // if(this.get_core_data
        // .all_echart_data.length<=0){
        //   this.ecShow=false
        // }
        // if (this.localProject === 8) {
        //   this.drawcontrastChart();
        //   this.drawcontrastChart2();
        // }
        // 从浏览器触发发送报告
        if ("screenshot" in this.$route.query) {
          this.save_report();
        }
      }
    } else {
      dispatchGetDateVersionList(store, {
        project: this.localProject,
      });
      dispatchRecentTaskrecord(store, { project: this.localProject }); //表格对应label
      // 获取当前报告名称列表
      await dispatchGetDcReport(store, {
        project: this.localProject,
        is_base: 0,
      });

      // 报告名称
      (this.name_search as any) = readGetDcReport(store)[0].cur_version;

      this.$router.push({
        query: { ...this.$route.query, cur_version: this.name_search },
      });
      await dispatchGetDc(store, {
        project: this.localProject,
        cur_version: this.name_search,
        test_time: "",
        base_version: "",
      });
      // (this.name_search as any) = this.$route.query.report_id;
      // 邮件标题
      // this.formMail.title = (readNewReportList(store) as any[]).filter(
      //   (item: any) => item.id === this.name_search
      // )[0].report_name;
      // 邮件收件人
      // 获取当前报告数据
      // await dispatchGetReportDetail(store, {
      //   project: this.localProject,
      //   id: Number(this.name_search),
      // });
      //调用获取性能报告接口
      // await dispatchGetPerfReport(store, {
      //   project: this.localProject,
      //   report_id: Number(this.name_search),
      // });
      // await dispatchGetProjectDetail(store, {
      //   id: this.localProject,
      //   project: this.localProject,
      // });
      //启用生成报告的接口
      this.resBase64 = [];
      await this.dc_Data();

      await this.Dc_Performance.forEach((v: any) => this.drawDcPerformance(v));
      await this.Core_indicators.forEach((v: any, index: any) =>
        this.drawCoreIndicators(v, index)
      );

      await this.dc_change_list;
      await this.getSpanArr(this.dc_change_list);
      await this.tableSecond();

      // if (this.get_core_data.auto_roadmap != undefined) {
      //   this.selected_scene1 =
      //     (this.get_core_data.auto_roadmap as any[])[0]?.scene || "";
      //   this.imgData = readPerfReport(store).auto_roadmap[0]?.roadmap;
      //   if (this.imgData.length > 0) {
      //     let deviceName = [];
      //     let deviceName1 = [];
      //     let dataObj = {};
      //     let dataObj1 = {};
      //     let FpsBox = [];
      //     let trajectoryBox = [];
      //     this.imgData.forEach((v) => {
      //       deviceName.push(v.device_name);
      //       this.column_list = deviceName;
      //       this.long = this.imgData?.length;
      //       dataObj[v.device_name] = v.fps;
      //     });
      //     deviceName1.push(this.imgData[0].device_name);
      //     dataObj1[this.imgData[0].device_name] = this.imgData[0].trajectory;
      //     trajectoryBox.push(dataObj1);
      //     this.newData1 = trajectoryBox;
      //     this.imgUrl = this.imgData[0].trajectory;
      //     console.log(this.newData1);

      //     this.column_list1 = deviceName1;
      //     FpsBox.push(dataObj);
      //     this.newData = FpsBox;
      //   }
      //   // this.imgData=[{device_name: "19X",fps: "../../assets/performance/footer.png",trajectory: "",}]
      // }
      // if (this.report_set.content.trend_scene) {
      //   if (this.report_set.content.trend_scene.length !== 0) {
      //     this.selected_scene = this.report_set.content.trend_scene[0];
      //   }
      // }
      // this.resBase64 = [];

      // if (this.localProject === 8) {
      //   this.drawcontrastChart();
      //   this.drawcontrastChart2();
      // }
      // 从浏览器触发发送报告
      if ("screenshot" in this.$route.query) {
        this.save_report();
      }
    }

    this.judgeModel();
    await this.addressee; //解析邮件收件人
    await this.getCorePerformance();
    this.loading = false;
  }

  //性能报告核心数据
  public perf_report() {
    this.get_core_data = readPerfReport(store);
  }
  //获取新报告数据
  public get addressee() {
    this.formMail.addressee = JSON.parse(
      readProjectDetail(store).report_settings
    ).notify.email.receiver_str;
    this.formMail.title =
      "【GR自动化】CFM 场景DrawCall采集测试报告---" +
      (this.dcData as any).base?.cur_version;
    return this.formMail.addressee;
  }

  // 核心指标风险详情
  public corePerformance: any[] = [];
  // 核心指标性能数据
  public getCorePerformance() {
    if (this.get_core_data.report_list.length > 0) {
      this.corePerformance.push({
        title: "新场景:",
        data: this.get_core_data.report_list,
        compare: this.get_core_data.core_devices1,
        edition: this.get_core_data.old_version,
      });
    }
    if (this.get_core_data.report_list1.length > 0) {
      this.corePerformance.push({
        title: "老场景:",
        data: this.get_core_data.report_list1,
        compare: this.get_core_data.core_devices2,
        edition: this.get_core_data.old_version1,
      });
    }

    return this.corePerformance;
  }

  //将新报告的JSON 字符串转换为对象。
  // public get report_set() {
  //   const settings = JSON.parse(this.new_report.settings);
  //   return settings.report_settings;
  // }
  public imgData: any = [];
  // 数值变化的规则配置
  public get rule_set() {
    const settings = JSON.parse(this.new_report.settings);
    return settings.rule_settings;
  }
  // 趋势对比
  // public compore_num(
  //   new_value: number,
  //   old_value: number,
  //   param: string,
  //   row?: any,
  //   device?: any
  // ) {
  //   let level = device?.level;
  //   let device_type = device?.type;
  //   if (device_type === 0) {
  //     device_type = "Android";
  //   } else if (device_type === 1) {
  //     device_type = "iOS";
  //   }
  //   if (!new_value) {
  //     return ["", "", ""];
  //   }
  //   let res: any = 0;
  //   if (old_value) {
  //     res = parseFloat((new_value - old_value).toFixed(1));
  //   }

  //   let risk = "";
  //   let color = ""; // 核心表格差值颜色
  //   let style = ""; // 核心表格原值颜色
  //   let new_color = ""; //详情表格差值颜色
  //   let is_rule = false;
  //   if (res !== 0) {
  //     // 风险判断,在increase_good中的上升标为绿色，下降为红色，如果配置有threshold，则变动超出阈值才标记颜色
  //     if (this.rule_set.change_rule.increase_good.includes(param)) {
  //       // 风险评估阈值(变化值)
  //       if (
  //         this.rule_set.risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           typeof this.rule_set.risk_rule?.[param] !== "number" &&
  //           this.rule_set.risk_rule?.[param].search("%") !== -1
  //         ) {
  //           // 阈值类型为百分比: 5%
  //           if (
  //             (old_value - new_value) / old_value >
  //             Number(
  //               this.rule_set.risk_rule?.[param].substring(
  //                 0,
  //                 this.rule_set.risk_rule?.[param].indexOf("%")
  //               )
  //             ) *
  //               0.01
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         } else {
  //           // 阈值类型为绝对值: 32
  //           if (
  //             old_value - new_value >
  //             Number(this.rule_set.risk_rule?.[param])
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         }
  //       }
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value <
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 颜色配置
  //       if (this.rule_set.change_rule.threshold?.[param]) {
  //         if (
  //           Math.abs(new_value - old_value) / old_value >
  //           this.rule_set.change_rule.threshold?.[param]
  //         ) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         }
  //       } else {
  //         if (res > 0) {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         } else {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         }
  //       }
  //     } else {
  //       if (
  //         this.rule_set.risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           typeof this.rule_set.risk_rule?.[param] !== "number" &&
  //           this.rule_set.risk_rule?.[param].search("%") !== -1
  //         ) {
  //           // 阈值类型为百分比: 5%
  //           if (
  //             (new_value - old_value) / old_value >
  //             Number(
  //               this.rule_set.risk_rule?.[param].substring(
  //                 0,
  //                 this.rule_set.risk_rule?.[param].indexOf("%")
  //               )
  //             ) *
  //               0.01
  //           ) {
  //             risk = "高风险";
  //             is_rule = true;
  //             this.com_risk = "高风险";
  //           }
  //         } else {
  //           // 阈值类型为绝对值: 32
  //           if (
  //             new_value - old_value >
  //             Number(this.rule_set.risk_rule?.[param])
  //           ) {
  //             is_rule = true;
  //             risk = "高风险";
  //             this.com_risk = "高风险";
  //           }
  //         }
  //       }
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value >
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // 颜色规则
  //       if (this.rule_set.change_rule.threshold?.[param]) {
  //         if (
  //           Math.abs(new_value - old_value) / old_value >
  //           this.rule_set.change_rule.threshold?.[param]
  //         ) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050";
  //         }
  //       } else {
  //         if (res > 0) {
  //           color = "#606266"; // 灰黑色
  //           new_color = "red";
  //         } else {
  //           color = "#00b050"; // 绿色
  //           new_color = "#00b050"; // 绿色
  //         }
  //       }
  //     }
  //     // 指标变化规则判断
  //     if (row) {
  //       if (res > 0) {
  //         res = "(" + Math.abs(res) + "↑" + ")";
  //       } else if (res < 0) {
  //         res = "(" + Math.abs(res) + "↓" + ")";
  //       }
  //     } else {
  //       if (res > 0) {
  //         res = Math.abs(res) + "↑";
  //       } else if (res < 0) {
  //         res = Math.abs(res) + "↓";
  //       }
  //     }
  //   } else {
  //     if (this.rule_set.change_rule.increase_good.includes(param)) {
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value < this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准, 按照设备的档位，类型判定风险, 判定规则：新版本数值超过阈值
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value <
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //     } else {
  //       // 风险评估阈值(绝对值)
  //       if (
  //         this.rule_set?.abs_risk_rule?.[param] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (new_value > this.rule_set?.abs_risk_rule?.[param]) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //       // TDR标准
  //       if (
  //         this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //           param
  //         ] &&
  //         this.report_set.content.core_index.includes(param)
  //       ) {
  //         if (
  //           new_value >
  //           this.rule_set.tdr_risk_rule?.[device_type]?.["level_" + level]?.[
  //             param
  //           ]
  //         ) {
  //           style = "color: red; font-weight: bold;";
  //           risk = "高风险";
  //           this.com_risk = "高风险";
  //         }
  //       }
  //     }
  //     res = row?"(--)":"";
  //   }

  //   if (risk === "高风险" && row) {
  //     row[param] = "高风险";
  //     if (!this.report_set.content.red_only_change_value) {
  //       style = "color: red; font-weight: bold;";
  //     }
  //     if (is_rule) {
  //       color = "red;font-weight: bold;";
  //     }
  //   } else {
  //     risk = "低风险";
  //   }
  //   if (this.report_set.content.core_color_rule) {
  //     // 核心指标标红规则, 变差就标红
  //     color = new_color;
  //   }
  //   // [差值, 风险, 核心表格差值颜色, 核心表格原值颜色, 详情表格差值颜色]
  //   return [res, risk, color, style, new_color];
  // }
  public get get_hero_skin_config() {
    return readHeroSkin(store);
  }
  public get get_scene_chinese() {
    return (
      this.scene_options.filter(
        (item) => item.scene_id === this.selected_scene
      )[0]?.chinese || "-"
    );
  }
  // 获取是否是moba项目
  public get is_in_moba_project() {
    const moba = readMobaProjects(store);
    return moba;
  }
  // 项目是否是王者荣耀
  public get projectIsKing() {
    //9
    if ((this.is_in_moba_project as any).includes(this.localProject)) {
      return true;
    } else {
      return false;
    }
  }
  public colorRisk(item) {
    if (item == "低风险") {
      return "#00b050";
    }
    if (item == "高风险") {
      return "red";
    } else if (item == "中风险") {
      return "#cd950c";
    }
  }
  public get_device_label(devie: string, index: number) {
    if (
      this.projectIsKing &&
      Object.keys(this.get_core_data.all_hero_skins).length !== 0
    ) {
      const hero =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item?.hero_id) ===
            this.get_core_data.all_hero_skins?.[devie]?.hero_id
        )[0]?.hero_name || "未知";
      const skin =
        (this.get_hero_skin_config.skin_list as any[]).filter(
          (item) =>
            Number(item.hero_id) ===
              this.get_core_data.all_hero_skins?.[devie]?.hero_id &&
            Number(item?.skin_id) ===
              this.get_core_data.all_hero_skins?.[devie]?.skin_id
        )[0]?.skin_name || "经典";
      return devie + "\n" + hero + "-" + skin;
    } else {
      return devie;
    }
  }
  //场景选项
  public get scene_options() {
    const scene = readPerfReport(store).all_echart_data; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene_id,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  public get scene_options1() {
    const scene = readPerfReport(store).auto_roadmap; //性能报告数据
    var sceneOptions: any[] = []; //场景
    for (let i in scene) {
      sceneOptions.push({
        scene_id: scene[i].scene,
        chinese: scene[i].scene,
      });
    }
    return sceneOptions;
  }
  // 获取机型
  public selected_device = "";
  public get Selected_device() {
    let Selected_device: any[] = [];
    this.get_core_data.all_device_id.forEach((element: any, index: any) => {
      Selected_device.push({
        label: this.get_core_data.all_devices[index],
        value: element,
      });
    });
    return Selected_device;
  }
  public setCellStyle(row, column, rowIndex, columnIndex) {
    if (row.columnIndex === 0) {
      return "text-align:left";
    } else {
      return "text-align:center";
    }
  }
  // 指标选项

  //点击切换场景时触发

  //   public auto_roadmap=[{a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"地铁副本测试"},
  // {a:{device_name: "小米10 Pro",
  // fps: null,
  // trajectory: null},scene:"黑铁"}
  // ]
  // 获取DC数据
  public dc_Data() {
    this.dcData = readGetDC(store);
  }
  public async selectSceneChange1(event: any) {
    let imgList = readPerfReport(store).auto_roadmap.filter(
      (v: any) => v.scene === event
    );
    this.imgData = imgList[0].roadmap;
    if (this.imgData.length > 0) {
      let deviceName = [];
      let deviceName1 = [];
      let dataObj = {};
      let dataObj1 = {};
      let FpsBox = [];
      let trajectoryBox = [];
      this.imgData.forEach((v) => {
        deviceName.push(v.device_name);
        this.column_list = deviceName;
        this.long = this.imgData?.length;
        dataObj[v.device_name] = v.fps;
      });
      deviceName1.push(this.imgData[0].device_name);
      dataObj1[this.imgData[0].device_name] = this.imgData[0].trajectory;
      this.imgUrl = this.imgData[0].trajectory;
      trajectoryBox.push(dataObj1);
      this.newData1 = trajectoryBox;

      this.column_list1 = deviceName1;
      FpsBox.push(dataObj);
      this.newData = FpsBox;
    }
  }
  // 点击切换机型的时候触发
  public get growth_details() {
    const list = [
      {
        name: "TOP图",
        value: ["团队运输船", "爆破_新年广场", "终极生化_新生化酒店"],
      },
      {
        name: "新图",
        value: [
          "团队-盲穿",
          "终极生化-大家一起抓肥羊",
          "跳跳乐-登顶",
          "跳跳乐-蛋糕小镇",
          "跳跳乐-镜花",
          "跳跳乐-青史光阴",
        ],
      },
    ];
    return list;
  }
  public subChart: any = [];
  //绘制图表准备
  // 原始数据处理
  public get getFPS_RawData() {
    const FPS_RawData: any = (this.get_core_data
      .all_echart_data as any[]).filter(
      (item: any) => item.scene_id === this.selected_scene
    )[0]?.echart_data;
    return FPS_RawData;
    // return FPS_RawData.reverse();
  }
  public get getDeviceSpecs() {
    // 设备列表
    const devices = readDeviceSpecs(store);
    return devices;
  }
  // 绘制图表
  public chDate0date(str) {
    let date = str?.replace(/(\d{4})(\d{2})(\d{2})/g, "$1-$2-$3");
    let date1 = date?.split("-");
    if (date1 != undefined) {
      return date1[0] + "年" + date1[1] + "月" + date1[2] + "日" + "版本";
    }
  }

  public removeDuplicates(arr: any) {
    const result: any = [];
    const duplicatesIndices: any = [];

    // 循环遍历原始数组中的每个项
    arr.forEach((current: any, index: any) => {
      if (duplicatesIndices.includes(index)) return;

      result.push(current);

      // 循环遍历数组中当前项之后的其他项
      for (
        let comparisonIndex = index + 1;
        comparisonIndex < arr.length;
        comparisonIndex++
      ) {
        const comparison = arr[comparisonIndex];
        const currentKeys = Object.keys(current);
        const comparisonKeys = Object.keys(comparison);

        // 检查对象中的键数
        if (currentKeys.length !== comparisonKeys.length) continue;

        // 检查关键字名称
        const currentKeysString = currentKeys.sort().join("").toLowerCase();
        const comparisonKeysString = comparisonKeys
          .sort()
          .join("")
          .toLowerCase();
        if (currentKeysString !== comparisonKeysString) continue;

        // 检查值
        let valuesEqual = true;
        for (let i = 0; i < currentKeys.length; i++) {
          const key = currentKeys[i];
          if (current[key] !== comparison[key]) {
            valuesEqual = false;
            break;
          }
        }
        if (valuesEqual) duplicatesIndices.push(comparisonIndex);
      }
    });

    return result;
  }
  //   public drawMap(){
  //      var chartDom = document.getElementById("map") as HTMLElement;
  //     var contrastChart = echarts.init(chartDom);
  //     const hours = [
  //     '12a', '1a', '2a', '3a', '4a', '5a', '6a',
  //     '7a', '8a', '9a', '10a', '11a',
  //     '12p', '1p', '2p', '3p', '4p', '5p',
  //     '6p', '7p', '8p', '9p', '10p', '11p'
  // ];
  // // prettier-ignore
  // const days = [
  //     'Saturday', 'Friday', 'Thursday',
  //     'Wednesday', 'Tuesday', 'Monday', 'Sunday'
  // ];
  // // prettier-ignore
  // const data = [[0, 0, 5], [0, 1, 1], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 2], [0, 12, 4], [0, 13, 1], [0, 14, 1], [0, 15, 3], [0, 16, 4], [0, 17, 6], [0, 18, 4], [0, 19, 4], [0, 20, 3], [0, 21, 3], [0, 22, 2], [0, 23, 5], [1, 0, 7], [1, 1, 0], [1, 2, 0], [1, 3, 0], [1, 4, 0], [1, 5, 0], [1, 6, 0], [1, 7, 0], [1, 8, 0], [1, 9, 0], [1, 10, 5], [1, 11, 2], [1, 12, 2], [1, 13, 6], [1, 14, 9], [1, 15, 11], [1, 16, 6], [1, 17, 7], [1, 18, 8], [1, 19, 12], [1, 20, 5], [1, 21, 5], [1, 22, 7], [1, 23, 2], [2, 0, 1], [2, 1, 1], [2, 2, 0], [2, 3, 0], [2, 4, 0], [2, 5, 0], [2, 6, 0], [2, 7, 0], [2, 8, 0], [2, 9, 0], [2, 10, 3], [2, 11, 2], [2, 12, 1], [2, 13, 9], [2, 14, 8], [2, 15, 10], [2, 16, 6], [2, 17, 5], [2, 18, 5], [2, 19, 5], [2, 20, 7], [2, 21, 4], [2, 22, 2], [2, 23, 4], [3, 0, 7], [3, 1, 3], [3, 2, 0], [3, 3, 0], [3, 4, 0], [3, 5, 0], [3, 6, 0], [3, 7, 0], [3, 8, 1], [3, 9, 0], [3, 10, 5], [3, 11, 4], [3, 12, 7], [3, 13, 14], [3, 14, 13], [3, 15, 12], [3, 16, 9], [3, 17, 5], [3, 18, 5], [3, 19, 10], [3, 20, 6], [3, 21, 4], [3, 22, 4], [3, 23, 1], [4, 0, 1], [4, 1, 3], [4, 2, 0], [4, 3, 0], [4, 4, 0], [4, 5, 1], [4, 6, 0], [4, 7, 0], [4, 8, 0], [4, 9, 2], [4, 10, 4], [4, 11, 4], [4, 12, 2], [4, 13, 4], [4, 14, 4], [4, 15, 14], [4, 16, 12], [4, 17, 1], [4, 18, 8], [4, 19, 5], [4, 20, 3], [4, 21, 7], [4, 22, 3], [4, 23, 0], [5, 0, 2], [5, 1, 1], [5, 2, 0], [5, 3, 3], [5, 4, 0], [5, 5, 0], [5, 6, 0], [5, 7, 0], [5, 8, 2], [5, 9, 0], [5, 10, 4], [5, 11, 1], [5, 12, 5], [5, 13, 10], [5, 14, 5], [5, 15, 7], [5, 16, 11], [5, 17, 6], [5, 18, 0], [5, 19, 5], [5, 20, 3], [5, 21, 4], [5, 22, 2], [5, 23, 0], [6, 0, 1], [6, 1, 0], [6, 2, 0], [6, 3, 0], [6, 4, 0], [6, 5, 0], [6, 6, 0], [6, 7, 0], [6, 8, 0], [6, 9, 0], [6, 10, 1], [6, 11, 0], [6, 12, 2], [6, 13, 1], [6, 14, 3], [6, 15, 4], [6, 16, 0], [6, 17, 0], [6, 18, 0], [6, 19, 0], [6, 20, 1], [6, 21, 2], [6, 22, 2], [6, 23, 6]]
  //     .map(function (item) {
  //     return [item[1], item[0], item[2] || '-'];
  // });

  // var img = new Image();
  // 	img.src = 'https://img2.baidu.com/it/u=2220565380,2694932281&fm=253&fmt=auto&app=138&f=JPEG?w=700&h=466';

  //   let option={}
  //   option = {

  // 		backgroundColor :{
  // 			image: require('../../assets/test/map.jpg'),
  // 			repeat: "no-repeat"
  // 		},
  //        tooltip: {
  //     position: 'top'
  //   },
  //   grid: {
  //     height: '50%',
  //     top: '10%'
  //   },
  //   xAxis: {
  //     type: 'category',
  //     data: hours,
  //     splitArea: {
  //       show: true
  //     },

  //     show: false
  //   },
  //   yAxis: {
  //     type: 'category',
  //     data: days,
  //     splitArea: {
  //       show: true
  //     },
  //     show: false
  //   },
  //   visualMap: {
  //     min: 0,
  //     max: 10,
  //     calculable: true,
  //     orient: 'horizontal',
  //     left: 'center',
  //     bottom: '15%',
  //     show:false,
  //     inRange:{
  //             color: ['rgba(0,255,0,0.1)','rgba(255,255,0,0.7)', 'rgba(255,0,0,0.1)']
  //         }
  //   },
  //   series: [
  //     {
  //       name: 'Punch Card',
  //       type: 'heatmap',
  //       data: data,
  //       label: {
  //         show: true
  //       },
  //       emphasis: {
  //         itemStyle: {
  //           shadowBlur: 10,
  //           shadowColor: 'rgba(0, 0, 0, 0.5)'
  //         }
  //       },

  //     }
  //   ]

  // 	}

  // 		contrastChart.setOption(option)

  //   }

  //报告筛选部分
  //风险等级
  public status_search: string | "" = "";
  public status_options = [
    {
      label: "高风险",
      value: "高风险",
    },
    {
      label: "低风险",
      value: "低风险",
    },
  ];
  //报告名称
  public name_search = "";
  //获取报告名称的列表
  public get nameList() {
    let name_list: any[] = [];
    name_list = readGetDcReport(store);

    return name_list;
  }
  // 编辑
  public dialogFormVisible1 = false;
  public formLabelWidth = "";
  public form1 = {
    name: "",
  };

  // public showEdit(){
  //   this.dialogFormVisible1 = true;
  //   console.log(this.name_search)
  //   this.form1.name=(readNewReportList(store) as any[]).filter(
  //       (item: any) => item.id === this.name_search
  //     )[0].report_name;
  // }
  // public handleEdit() {
  //   this.dialogFormVisible1 = true;
  //   this.form1.name = (readNewReportList(store) as any[]).filter(
  //     (item: any) => item.id === this.name_search
  //   )[0].report_name;

  // }

  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateReport(store, {
      project: this.localProject,
      id: Number(this.name_search),
      report_name: String(this.form1.name),
    });
    // (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.name_search
    // )[0].report_name = this.form1.name;
  }
  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public target(a: any) {
    if (a == undefined || a == null || a == "") {
      return;
    } else {
      window.open(this.get_url(a), "_blank");
    }
  }
  // 复制数据
  public copyVal = {
    taskRecordId: "", //任务记录id
    deviceVal: "", //任务记录设备
  };
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  public get Dc_Performance() {
    const list = [
      { name: "TOP图-MAXDC趋势", value: "top_max_dc_trend" },
      { name: "PGC模式地图-MAXDC趋势", value: "pgc_max_dc_trend" },
    ];
    return list;
  }
  // DC性能
  public drawDcPerformance(item) {
    let list = [];
    this.dcData[item.value].scene_list.forEach((v, i) => {
      list.push({
        data: this.dcData[item.value].series[i],
        type: "line",
        name: v,
        symbol: "rect",
        symbolSize: 10,
        tooltip: {
          trigger: "axis",
        },
      });
    });

    var chartDom = document.getElementById(
      "performance" + item.value
    ) as HTMLElement;
    var contrastChart = echarts.init(chartDom);
    contrastChart.setOption({
      title: {
        text: item.name,
        subtext: "数据来源GameRobot Test",
        x: "center",
        y: "top",

        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      animation: false,
      xAxis: [
        {
          type: "category",
          data: this.dcData[item.value].x,
          splitLine: {
            show: true,
          },

          axisTick: false,
          // axisLine: {
          //   show: true,
          // },
          gridIndex: 0,
        },
        {
          //上方线
          gridIndex: 1,
          axisLine: {
            show: true,
          },
        },
        {
          //下方线
          gridIndex: 2,
        },
      ],

      yAxis: [
        {
          name: "DC数量(个)",
          type: "value",

          splitLine: {
            show: true,
          },
          nameLocation: "middle",
          // 坐标轴名称与轴线之间的距离。
          nameGap: 35,
          nameRotate: 90,
          axisTick: false,
          //左侧线
          axisLine: {
            show: true,
          },
          gridIndex: 0,
        },
        {
          gridIndex: 0,
          //右侧线
          axisLine: {
            show: true,
          },
        },
        {
          gridIndex: 1,
        },
        {
          gridIndex: 2,
        },
      ],

      grid: [
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
        },
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
          height: "0%",
        },
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
        },
      ],
      legend: {
        x: "center",
        y: "bottom",
        data: this.dcData[item.value].scene_list,
      },
      series: list,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.type = item.value;
    // res.filename = "report" + type + ".png";
    res.filename =
      "report" +
      item.value +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.cur_version +
      ".png";
    this.resBase64.push(res);
    // contrastChart.setOption({
    //   title: {
    //     text: "TOP图-MAXDC趋势",
    //     textStyle: {
    //       fontSize: 13,
    //     },
    //   },
    //   tooltip: {
    //       trigger: "axis",
    //     },

    //   xAxis: {
    //     type: "category",
    //     boundaryGap: false,
    //     data: [1, 2, ],
    //      axisLabel: {
    //         interval: 0,
    //       },
    //   },
    //   yAxis: {
    //     type: "value",
    //     name: `好心情数量`,
    //     nameLocation: "middle",
    //     nameGap: 35,
    //     nameRotate: 90,
    //   },
    //    grid: {
    //       left: "4%",
    //       top: "10%",
    //       bottom: "20%",
    //       right: "4%",
    //       containLabel: true,
    //     },
    //   legend: {
    //      x: "center",
    //       y: "bottom",
    //     data: ["爆破_新年广场", "团队_运输船", "终极生化_新生化酒店"],
    //   },
    //   animation: false,
    //   series: [
    //     {
    //       name: "爆破_新年广场",
    //       data: [15, 20, 35],
    //       type: "line",
    //        smooth: true, // 平滑曲线
    //       symbol: "circle", //拐点设置为实心
    //      itemStyle: {
    //         normal: {
    //           label: {
    //             // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //             show: true,
    //           },
    //         },
    //       },
    //     },
    //     {
    //       name: "团队_运输船",
    //       data: [25, 45, 30],
    //       type: "line",
    //        smooth: true, // 平滑曲线
    //       symbol: "circle", //拐点设置为实心
    //        itemStyle: {
    //         normal: {
    //           label: {
    //             // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //             show: true,
    //           },
    //         },
    //       },
    //     },
    //     {
    //       name: "终极生化_新生化酒店",
    //       data: [25, 45, 30],
    //       type: "line",
    //        smooth: true, // 平滑曲线
    //       symbol: "circle", //拐点设置为实心
    //       itemStyle: {
    //         normal: {
    //           label: {
    //             // show: this.getFPS_RawData.device_names.length <= 3 ? true : false,
    //             show: true,
    //           },
    //         },
    //       },
    //     },
    //   ],
    // });
  }

  public drawCoreIndicators(item, i) {
    let list = [];
    (this.dcData as any).dc_trend[item].versions.forEach((v, i) => {
      list.push({
        data: (this.dcData as any).dc_trend[item].series[i],
        type: "line",
        name: v,
        symbol: "rect",
        symbolSize: 10,
        tooltip: {
          trigger: "axis",
        },
      });
    });
    var chartDom = document.getElementById(
      "performance_line" + item
    ) as HTMLElement;
    var contrastChart = echarts.init(chartDom);
    contrastChart.setOption({
      title: {
        text: item + "-局内DC趋势(四个方向总和)",
        subtext: "数据来源GameRobot Test",
        x: "center",
        y: "top",
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      animation: false,
      xAxis: [
        {
          type: "category",
          data: (this.dcData as any).dc_trend[item].x,
          splitLine: {
            show: true,
          },

          axisTick: false,
          // axisLine: {
          //   show: true,
          // },
          gridIndex: 0,
        },

        {
          //上方线
          gridIndex: 1,
          axisLine: {
            show: true,
          },
        },
        {
          //下方线
          gridIndex: 2,
        },
      ],

      yAxis: [
        {
          name: "DC数量(个)",
          type: "value",

          splitLine: {
            show: true,
          },
          nameLocation: "middle",
          // 坐标轴名称与轴线之间的距离。
          nameGap: 35,
          nameRotate: 90,
          axisTick: false,
          //左侧线
          axisLine: {
            show: true,
          },
          gridIndex: 0,
        },
        {
          gridIndex: 0,
          //右侧线
          axisLine: {
            show: true,
          },
        },
        {
          gridIndex: 1,
        },
        {
          gridIndex: 2,
        },
      ],

      grid: [
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
        },
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
          height: "0%",
        },
        {
          top: 60,
          right: 60,
          left: 60,
          bottom: 60,
        },
      ],
      legend: {
        x: "center",
        y: "bottom",
        data: (this.dcData as any).dc_trend[item].versions,
      },
      series: list,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.type = item;
    // res.filename = "report" + type + ".png";
    res.filename =
      "report" +
      i +
      "_project" +
      this.localProject +
      "_report" +
      this.$route.query.cur_version +
      ".png";
    this.resBase64.push(res);
  }
  public dcData = {};
  // 获取DC数据
  // public  get  dc_Data(){

  // }
  // 点击删除
  // public async handleDelete() {
  //   // this.loading = true;

  //   await dispatchDeleteReport(store, {
  //     project: this.localProject,
  //     report_id: Number(this.name_search),
  //     page: 1,
  //     size: 1,
  //     report_name: "",
  //     new_version: "",
  //     old_version: "",
  //     risk: "",
  //     creator: "",
  //   });
  //   await dispatchGetDcReport(store, {
  //     project: this.localProject,
  //     is_base: 1
  //   });
  //   this.name_search = readNewReportList(store)[0].id;

  //   // 获取当前报告数据
  //   await dispatchGetReportDetail(store, {
  //     project: this.localProject,
  //     id: Number(this.name_search),
  //   });
  //   //调用获取性能报告接口
  //   await dispatchGetPerfReport(store, {
  //     project: this.localProject,
  //     report_id: Number(this.name_search),
  //   });

  //   //启用生成报告的接口
  //   await this.get_create_report();
  //   await this.perf_report();

  //   // this.selected_scene =
  //   //   (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
  //   // if (this.report_set.content.trend_scene) {
  //   //   if (this.report_set.content.trend_scene.length !== 0) {
  //   //     this.selected_scene = this.report_set.content.trend_scene[0];
  //   //   }
  //   // }
  //   this.resBase64 = [];

  //   if (this.localProject === 8) {
  //     this.drawcontrastChart();
  //     this.drawcontrastChart2();
  //   }
  //   // 从浏览器触发发送报告
  //   if ("screenshot" in this.$route.query) {
  //     this.save_report();
  //   }
  //   this.judgeModel();

  //   // await this.addressee; //解析邮件收件人
  //   // await dispatchtaskRecordDevices(store, {
  //   //   project: this.localProject,
  //   //   task_record_id: "",
  //   // }); //获取任务记录的设备
  //   this.corePerformance = [];
  //   await this.getCorePerformance();

  //   // this.loading = false;
  // }

  public get screenshot() {
    if ("screenshot" in this.$route.query) {
      return false;
    } else {
      return true;
    }
  }

  public resBase64: any[] = [];
  发送报告;
  public async save_report() {
    let upload_data: any;
    upload_data = {
      // project: Number(this.$route.query.project),
      project: Number(this.localProject),
      cur_version: this.nameList.filter(
        (v) => v.cur_version == this.name_search
      )[0].cur_version,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
    };

    dispatchGetDcReportImage(store, upload_data);
    ElMessage({
      //Message 消息提示
      message: "报告发送中...",
      showClose: true,
    });
    this.edit = false;
  }
  //  public async save_report() {
  //   let upload_data: any;
  //   upload_data = {
  //     // project: Number(this.$route.query.project),
  //     project: Number(this.localProject),
  //     report_id: Number(this.name_search),
  //     file_list: this.resBase64,
  //     title: this.formMail.title,
  //     recv: this.formMail.addressee,
  //     cc: this.formMail.CC_List,
  //     send: this.formMail.Sender,
  //   };
  //   dispatchSendXhookReport(store, upload_data);
  //   ElMessage({
  //     //Message 消息提示
  //     message: "报告发送中...",
  //     showClose: true,
  //   });
  //   this.edit = false;
  // }
  public get dc_change_list() {
    let list = [];
    for (let i in (this.dcData as any).dc_change_list) {
      (this.dcData as any).dc_change_list[i].forEach((v) => {
        list.push(v);
      });
    }

    return list;
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 判断安卓/ios
  public modelVal = "安卓";
  public judgeModel() {
    let ad_new = this.get_core_data.able_versions.android_new_version;
    let ad_old = this.get_core_data.able_versions.android_old_version;
    let ios_new = this.get_core_data.able_versions.ios_new_version;
    let ios_old = this.get_core_data.able_versions.ios_old_version;
    if (
      (ad_new !== "" || ad_old !== "") &&
      (ios_new !== "" || ios_old !== "")
    ) {
      this.modelVal = "安卓/iOS";
    } else if (ios_new !== "" || ios_old !== "") {
      this.modelVal = "iOS";
    }
    return this.modelVal;
  }

  // 链接
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }

  // 获取所有的索引
  public all_index(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexs = [];
    indexs.push(...index.basic);
    indexs.push(...index.advance);
    indexs.push(...index.customize);
    indexs.push(...custom_index);
    return indexs;
  }

  // 索引分类
  public indexClassification(custom_index: string[]) {
    const settings = JSON.parse(this.new_report.settings);
    const index = settings.report_settings.content.index_type;
    let indexClassification: any[] = [];
    indexClassification.push({
      indexClassification: "指标分类",
      dataItem: "数据项",
    });
    (index.basic as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "基础指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.advance as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "深度指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    (index.customize as any[]).forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: this.get_field(item),
        style: { "background-color": "#5d99d5" },
      })
    );
    custom_index.forEach((item) =>
      indexClassification.push({
        indexClassification: "定制指标",
        dataItem: item,
        style: { "background-color": "#5d99d5" },
      })
    );
    return indexClassification;
  }
  public time: any = "";
  public reload() {
    this.time = new Date().getTime();
  }
  // 判断是否出现滚动条
  public scroll = false;

  // // 解析邮件收件人
  // public get addressee() {
  //   console.log(JSON.parse(readNewReport(store).settings));
  //   let addressee = JSON.parse(readNewReport(store).settings).report_settings
  //     .notify.email.receiver_str;
  //   this.formMail.addressee = addressee;

  //   return addressee;
  // }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }

  // 报告名称切换时
  public async change_name_search() {
    this.loading = true;
    // 获取当前报告名称列表
    await dispatchGetDcReport(store, {
      project: this.localProject,
      is_base: 0,
    });
    // 报告名称
    // this.name_search = readGetDcReport(store)[0].id;

    this.$router.push({
      query: { ...this.$route.query, cur_version: this.name_search },
    });

    await dispatchGetDc(store, {
      project: this.localProject,
      cur_version: this.name_search,
      test_time: "",
      base_version: "",
    });

    //启用生成报告的接口
    this.resBase64 = [];
    await this.dc_Data();
    await this.Dc_Performance.forEach((v: any) => this.drawDcPerformance(v));
    await this.Core_indicators.forEach((v: any, index: any) =>
      this.drawCoreIndicators(v, index)
    );

    await this.dc_change_list;
    this.spanArr = [];
    await this.getSpanArr(this.dc_change_list);
    await this.tableSecond();

    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }

    // if (this.localProject === 8) {
    //   this.drawcontrastChart();
    //   this.drawcontrastChart2();
    // }

    // 从浏览器触发发送报告
    if ("screenshot" in this.$route.query) {
      this.save_report();
    }
    this.judgeModel();

    await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备

    this.loading = false;
  }
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public dialogFormVisibleByTask = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };

  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称

  // 打开生成报告
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  public generateReportsManuallyByTask() {
    this.dialogFormVisibleByTask = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-new";
  }
  //获取下拉选择选项
  // public get getPerformanceSelectOptions() {
  //   return readPerformanceSelectOptions(store);
  // }
  public get getDateVersions() {
    return readDateVersions(store);
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    // const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const versions = this.getDateVersions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item.value) {
        game_version_select.push({
          label: item.label,
          value: item.value,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    // if (
    //   this.generateReportVersion.oldEdition ===
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("版本号不能相同哦！");
    //   return;
    // }
    // if (
    //   this.generateReportVersion.oldEdition >
    //   this.generateReportVersion.newEdition
    // ) {
    //   alert("新版本号不能小于旧版本！");
    //   return;
    // }
    this.loading = true;
    this.dialogFormVisible = false;

    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      scene_list: this.generateReportVersion.scenetion,
      // report_name: this.report_name_placeholder,
    });

    // 获取当前报告名称列表
    await dispatchGetDcReport(store, {
      project: this.localProject,
      is_base: 0,
    });
    // 报告名称

    // this.name_search = readNewReportList(store)[0].id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.name_search
    // )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: readNewReportList(store)[0].id,
    // });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: readNewReportList(store)[0].id,
    // });

    //启用生成报告的接口

    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    // if (this.localProject === 8) {
    //   this.drawcontrastChart();
    //   this.drawcontrastChart2();
    // }
    this.judgeModel();

    // await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();

    this.loading = false;
    this.dialogFormVisible = false;
  }
  // 生成报告
  public async generateReportByTask() {
    this.loading = true;
    this.dialogFormVisibleByTask = false;

    await dispatchCreateReportByTask(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      task_record_id: Number(this.generateReportVersion.newEdition),
      old_record_id: Number(this.generateReportVersion.oldEdition),
      allow: this.contrast,
    });

    // 获取当前报告名称列表
    await dispatchGetDcReport(store, {
      project: this.localProject,
      is_base: 0,
    });
    // 报告名称
    this.name_search = readGetDcReport(store)[0].cur_version;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.name_search },
    });
    // 邮件标题
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.name_search
    // )[0].report_name;
    // 邮件收件人
    // 获取当前报告数据
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: readNewReportList(store)[0].id,
    // });
    //调用获取性能报告接口
    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: readNewReportList(store)[0].id,
    // });

    //启用生成报告的接口

    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    // if (this.localProject === 8) {
    //   this.drawcontrastChart();
    //   this.drawcontrastChart2();
    // }
    this.judgeModel();

    // await this.addressee; //解析邮件收件人
    // await dispatchtaskRecordDevices(store, {
    //   project: this.localProject,
    //   task_record_id: "",
    // }); //获取任务记录的设备
    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }

  // 激活报告名称
  // public activation(val: boolean) {
  //   if (val) {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition;
  //   } else {
  //     this.report_name_placeholder =
  //       "【GR自动化性能】" +
  //       this.get_project_name +
  //       " -" +
  //       this.generateReportVersion.newEdition.split("|")[0];
  //   }
  // }

  // 得到项目名称
  // public get get_project_name() {
  //   const project_name = readProjectDetail(store).project_name;
  //   return project_name;
  // }
  public get Core_indicators() {
    const list = [];
    for (let i in (this.dcData as any).dc_trend) {
      list.push(i);
    }
    return list;
  }
  // 切换复制的id时，更新设备数据
  public async equipmentUpdate() {
    await dispatchtaskRecordDevices(store, {
      project: this.localProject,
      task_record_id: Number(this.copyVal.taskRecordId),
    });
  }

  // 获取复制需要的任务id下拉框
  public get TaskRecordQuery() {
    return readTaskRecordQuery(store);
  }
  public get testData() {
    let list = [];
    list = [
      {
        name: "TOP图",
        value: "运输船",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
      {
        name: "TOP图",
        value: "爆破新年广场",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
      {
        name: "TOP图",
        value: "终极生化_新生化酒店",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
      {
        name: "PGC模式新图",
        value: "团队-盲穿 ",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
      {
        name: "PGC模式新图",
        value: "终极生化-先锋航母号",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
      {
        name: "PGC模式新图",
        value: "终极生化-大家一起抓肥羊",
        dcMax: "456(100,58,153,145)",
        dc: "0(0,0,0,0)",
      },
    ];
    return list;
  }

  public spanArr = [];
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].test_content === data[i - 1].test_content) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public textDc =
    "(版本迭代DC风险标准,DC增量<=10,低风险;10<=DC增量<15,中风险;DC增量>=15,高风险)";
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const _row = this.spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;

      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  // 获取复制需要的设备数据下拉框
  public get TaskRecordDevices() {
    return readTaskRecordDevices(store);
  }

  //复制的接口
  public async CopyBtn() {
    this.loading = true;
    let copy = {
      project: this.localProject,
      task_record_id: this.copyVal.taskRecordId,
      device_id: this.copyVal.deviceVal,
      report_id: Number(this.$route.query.report_id),
    };
    await dispatchAovCopyPerfToReport(store, copy);
    // await dispatchGetReportDetail(store, {
    //   project: this.localProject,
    //   id: readNewReportList(store)[0].id,
    // });
    //调用获取性能报告接口

    // await dispatchGetPerfReport(store, {
    //   project: this.localProject,
    //   report_id: Number(this.$route.query.report_id),
    // });

    //启用生成报告的接口

    await this.perf_report();

    this.selected_scene =
      (this.get_core_data.all_echart_data as any[])[0]?.scene_id || ""; //场景iD
    // if (this.report_set.content.trend_scene) {
    //   if (this.report_set.content.trend_scene.length !== 0) {
    //     this.selected_scene = this.report_set.content.trend_scene[0];
    //   }
    // }
    this.resBase64 = [];

    this.corePerformance = [];
    await this.getCorePerformance();
    this.loading = false;
  }
  // 复制接口禁用
  public get interfaceDisabled() {
    let disabled = false;
    if (
      this.get_is_super ||
      this.copyVal.taskRecordId === "" ||
      this.copyVal.deviceVal === "" ||
      this.copyVal.deviceVal === undefined
    ) {
      disabled = true;
    }
    return disabled;
  }
}
